import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { SUPPLIER_PATH } from '../../../../config/paths';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import SupplierBasicInformationResource from './resource/SupplierBasicInformationResource';
import SupplierToolbar from './SupplierToolbar';
import { clearSupplier, getSupplier } from '../../../../actions/food/Supplier';

export const Supplier = ({
  breadcrumbs,
  dispatchGetSupplier,
  dispatchClearSupplier,
  match: {
    params: { id: supplierId },
  },
  loading,
  supplier,
}) => {
  useLayoutEffect(() => {
    dispatchGetSupplier({ supplierId });

    return () => dispatchClearSupplier();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (supplier.isEmpty())
    content = <NoDataResource returnPage={SUPPLIER_PATH} />;
  else {
    const supplierJson = supplier.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <SupplierBasicInformationResource {...supplierJson} />
      </>
    );

    toolbar = <SupplierToolbar supplierId={supplierJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Proveedor"
      content={content}
    />
  );
};

Supplier.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearSupplier: PropTypes.func.isRequired,
  dispatchGetSupplier: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  supplier: PropTypes.instanceOf(Immutable.Map).isRequired,
};

Supplier.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearSupplier: clearSupplier,
  dispatchGetSupplier: getSupplier,
};

const mapStateToProps = ({ FoodUnit }) => ({
  breadcrumbs: [
    ...FoodUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Proveedores',
      href: SUPPLIER_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  supplier: FoodUnit.Supplier.getIn(['current', 'content']),
  loading: !FoodUnit.Supplier.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(Supplier);
